module.exports = __webpack_public_path__ + "img/logo_default.af107068.png";